var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia, shapes } from '@joint/plus';
var Node = /** @class */ (function (_super) {
    __extends(Node, _super);
    function Node() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'rect',
                selector: 'rect'
            }, {
                tagName: 'text',
                selector: 'text',
            }];
        return _this;
    }
    Node.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'ast.Node', attrs: {
                rect: {
                    width: 'calc(w)',
                    height: 'calc(h)',
                    rx: 5,
                    ry: 5,
                    stroke: 'none',
                    cursor: 'pointer'
                },
                text: {
                    textWrap: { width: -30 },
                    pointerEvents: 'none',
                    x: 'calc(0.5 * w)',
                    y: 'calc(0.5 * h)',
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    fill: 'white',
                    fontSize: 10,
                    fontFamily: '\'Helvetica Neue Light\',\'Helvetica Neue\',\'Source Sans Pro\',sans-serif',
                    letterSpacing: '1px'
                }
            } });
    };
    return Node;
}(dia.Element));
export { Node };
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'ast.Link', attrs: {
                line: {
                    connection: true,
                    fill: 'none',
                    stroke: '#666',
                    strokeWidth: 2,
                    pointerEvents: 'none',
                    targetMarker: {
                        type: 'path',
                        fill: '#666',
                        stroke: '#666',
                        d: 'M 4 -4 0 0 4 4 z'
                    }
                }
            } });
    };
    return Link;
}(shapes.standard.Link));
export { Link };
export var astShapes = {
    ast: {
        Node: Node,
        Link: Link
    }
};
